import { useState } from 'react';

const useShimmer = (ShimmerComponent) => {
  const [isLoading, setLoading] = useState(false);

  return [
    isLoading ? <ShimmerComponent /> : null,
    setLoading,
  ];
};

export default useShimmer;
